import React, { FC } from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { TableSmall } from '../../../../../components/Dashboard/TableSmall'
import { data } from './QuotesTableList'
import { instrumentsSelector } from '../../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  section: {
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    padding: theme.spacing(4, 4, 2, 4),
    background: theme.palette.background.paper,
  },
}))

export const Quotes: FC = () => {
  const classes = useStyles()
  const instruments = useSelector(instrumentsSelector)

  return (
    <Grid item xs={12} className={classes.wrap}>
      <Grid item xs={12} className={classes.container}>
        <Typography variant={'h6'}>Quotes</Typography>
      </Grid>

      <Grid container item xs={12} className={classes.section}>
        <TableSmall
          columns={data.columns}
          data={instruments}
          pb={16}
          paginationMT={16}
          params={{
            currentPage: 1,
            itemsPerPage: 10,
            itemCount: 0,
            totalItems: 0,
            totalPages: 0,
          }}
          loading={false}
          // loadData={loadReferrals}
        />
      </Grid>
    </Grid>
  )
}
